export default __webpack_public_path__ + "static/blog-04-500x338-9a86d87dd2acbdb0e6feff44aa7742c6.jpg";